<template>
  <v-card class="pa-4">
    <h3 class="text-center my-2">
      {{ isEditing ? $t('Atualizar item padrão') : $t('Novo item padrão') }}
    </h3>

    <v-form ref="form">
      <v-row class="ma-0" dense>
        <v-col cols="12">
          <span class="text ml-1">{{ $t('Nome do item') }}</span>
          <v-text-field
            v-model="item.name"
            class="primary-input"
            :placeholder="$t('Insira o nome do item')"
            :rules="[(v) => !!v || 'Nome obrigatório']"
            outlined
            hide-details="auto"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="12">
          <span class="text ml-1">Departamento</span>
          <v-autocomplete
            v-model="item.departmentType"
            :items="departmentTypes"
            append-icon="mdi-chevron-down"
            item-text="text"
            item-value="value"
            class="primary-input"
            :rules="[(v) => v != null || 'Departamento obrigatório']"
            outlined
            hide-details="auto"
          >
          </v-autocomplete>
        </v-col>

        <v-col>
          <span class="text ml-1">{{ $t('Classe de Checklist') }}</span>
          <v-autocomplete
            :loading="classLoading"
            :items="classes"
            item-text="name"
            item-value="id"
            v-model="item.checklistItemClassId"
            append-icon="mdi-chevron-down"
            class="primary-input"
            :rules="[(v) => !!v || 'Classe obrigatória']"
            :placeholder="$t('Pesquisar por nome')"
            outlined
            hide-details="auto"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-form>

    <div class="d-flex justify-end mt-4">
      <v-btn class="secondary-button" depressed @click="$emit('close')">
        Cancelar
      </v-btn>
      <v-btn
        :loading="loading"
        class="primary-button"
        depressed
        @click="submit"
      >
        {{ isEditing ? $t('Atualizar') : $t('Cadastrar') }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
export default {
  name: 'ManageStandardChecklistItem',

  props: {
    checklistItem: Object,
  },

  created() {
    this.getChecklisItemClasses()
    if (this.checklistItem.id) {
      this.item = this.checklistItem
      this.isEditing = true
    }
  },

  data() {
    return {
      apiService: new ApiService(),
      isEditing: false,
      loading: false,
      item: {},
      classLoading: false,
      classes: [],
      departmentTypes: [
        { text: 'Engenharia clínica', value: 0 },
        { text: 'Manutenção predial', value: 1 },
      ],
    }
  },

  methods: {
    async getChecklisItemClasses() {
      this.classLoading = true

      await this.apiService.get(`checklistItemClass/list`).then((response) => {
        this.classes = response.content
        this.classLoading = false
      })
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true

        if (this.isEditing) {
          this.apiService
            .put('standardChecklistItem/edit', this.item)
            .then(() => {
              this.$emit('confirm')
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.apiService
            .post('standardChecklistItem/add', this.item)
            .then(() => {
              this.$emit('confirm')
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        }
      }
    },
  },
}
</script>

<style scoped></style>
